var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntegratedSystemIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10779",
    "data-name": "Group 10779",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 76,
    viewBox: "0 0 80 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5975",
    "data-name": "Rectangle 5975",
    width: 80,
    height: 76,
    fill: "#77191a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10778",
    "data-name": "Group 10778",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30824",
    "data-name": "Path 30824",
    d: "M33.373,23.611a7.131,7.131,0,1,1-7.131-7.078,7.105,7.105,0,0,1,7.131,7.078",
    transform: "translate(-7.484 -6.549)",
    fill: "#77191a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30825",
    "data-name": "Path 30825",
    d: "M99.5,7.078A7.131,7.131,0,1,1,92.374,0,7.105,7.105,0,0,1,99.5,7.078",
    transform: "translate(-33.383 0)",
    fill: "#77191a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30826",
    "data-name": "Path 30826",
    d: "M122.317,62.6a7.131,7.131,0,1,1-7.131-7.078,7.105,7.105,0,0,1,7.131,7.078",
    transform: "translate(-42.317 -21.991)",
    fill: "#77191a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30827",
    "data-name": "Path 30827",
    d: "M81.109,109.483a7.131,7.131,0,1,1-7.131-7.078,7.105,7.105,0,0,1,7.131,7.078",
    transform: "translate(-26.179 -40.562)",
    fill: "#77191a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30828",
    "data-name": "Path 30828",
    d: "M14.262,75.924a7.131,7.131,0,1,1-7.131-7.078,7.105,7.105,0,0,1,7.131,7.078",
    transform: "translate(0 -27.269)",
    fill: "#77191a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30829",
    "data-name": "Path 30829",
    d: "M71.092,54.918A11.918,11.918,0,1,1,59.174,43.087,11.875,11.875,0,0,1,71.092,54.918",
    transform: "translate(-18.506 -17.066)",
    fill: "#77191a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30830",
    "data-name": "Path 30830",
    d: "M42.348,41.02a2.13,2.13,0,0,1-1.5-.618L34.31,33.915a2.1,2.1,0,0,1,0-2.985,2.138,2.138,0,0,1,3.007,0l6.535,6.487a2.1,2.1,0,0,1,0,2.986,2.13,2.13,0,0,1-1.5.618",
    transform: "translate(-13.192 -12.006)",
    fill: "#77191a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30831",
    "data-name": "Path 30831",
    d: "M81.268,30.348a2.125,2.125,0,0,1-1.061-.283,2.1,2.1,0,0,1-.779-2.884l4.621-7.944a2.138,2.138,0,0,1,2.905-.773,2.1,2.1,0,0,1,.779,2.884l-4.621,7.944a2.128,2.128,0,0,1-1.844,1.056",
    transform: "translate(-30.994 -7.202)",
    fill: "#77191a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30832",
    "data-name": "Path 30832",
    d: "M21.018,75.58a2.127,2.127,0,0,1-1.979-1.338,2.106,2.106,0,0,1,1.2-2.738l8.6-3.366a2.13,2.13,0,0,1,2.758,1.19,2.1,2.1,0,0,1-1.2,2.738l-8.6,3.366a2.152,2.152,0,0,1-.78.148",
    transform: "translate(-7.398 -26.931)",
    fill: "#77191a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30833",
    "data-name": "Path 30833",
    d: "M72.482,97.284a2.125,2.125,0,0,1-2.065-1.614L68.24,86.754a2.126,2.126,0,0,1,4.134-.994l2.176,8.916a2.123,2.123,0,0,1-2.068,2.608",
    transform: "translate(-26.701 -33.329)",
    fill: "#77191a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30834",
    "data-name": "Path 30834",
    d: "M104.774,67.256a2.435,2.435,0,0,1-.255-.014l-9.177-1.088a2.115,2.115,0,0,1-1.859-2.347,2.14,2.14,0,0,1,2.364-1.846l9.177,1.087a2.111,2.111,0,0,1-.25,4.208",
    transform: "translate(-36.604 -24.538)",
    fill: "#77191a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegratedSystemIcon);
export default __webpack_public_path__ + "static/media/IntegratedSystemIcon.eb4fe6cc6a4d26734fb7c2a554890ec7.svg";
export { ForwardRef as ReactComponent };